var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckMark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "1 1 11 11",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Dashboard-mobile---Checklist_likePro",
    transform: "translate(-33.000000, -307.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Progress-Bar-/-Checkpoint-Copy-3",
    transform: "translate(33.000000, 307.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-7",
    stroke: "currentColor",
    strokeWidth: 2,
    points: "3.75 5.93814744 5.84958506 7.885 8.75 3"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checkMark.9c4af43d.svg";
export { ForwardRef as ReactComponent };